// extracted by mini-css-extract-plugin
export default {"LeftMenu":"LeftMenu_LeftMenu__wxGAo"};